<section class="groove-section-even">
    <div class="groove-section-even__section">
      <article class="groove-section-even__background" [ngStyle]="{ 'background-image': 'url(' + imageDescription.url + ')'}" *ngIf="imageDescription">
        <div class="container groove-section-even__content">
          <section class="row">
            <article class="col-lg-6"></article>
            <article class="homepage-section__column col-lg-6">
              <div class="homepage-section__caption">
                <fitscovery-ui-markdown-viewer [content]="imageDescription.caption!"></fitscovery-ui-markdown-viewer>
              </div>
              <div class="homepage-section__description">
                <fitscovery-ui-markdown-viewer [content]="imageDescription.description!"></fitscovery-ui-markdown-viewer>
              </div>
              <div class="homepage-section__buttons">
                <ng-container *ngFor="let button of imageDescription.buttons">
                  <div class="d-flex" [ngClass]="setButtonAlignmentClass(button)">
                    <fitscovery-ui-custom-button class="mx-lg-0 mx-auto" [button]="button"
                      [email]="partner.contactInfo!.email" [homePageVersion]="partner.appConfig!.homePageVer!">
                    </fitscovery-ui-custom-button>
                  </div>
                </ng-container>
              </div>
            </article>
          </section>
        </div>
        <div class="groove-section__banner-mobile mt-5">
          <img src="{{ imageDescription.url }}" alt="" class="w-100">
        </div>
      </article>
    </div>
  </section>